import { render, staticRenderFns } from "./categories-queries-aside.component.vue?vue&type=template&id=4f4b883c&scoped=true"
import script from "./categories-queries-aside.component.vue?vue&type=script&lang=ts"
export * from "./categories-queries-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./categories-queries-aside.component.vue?vue&type=style&index=0&id=4f4b883c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b883c",
  null
  
)

export default component.exports